import React, { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { GeoPoint } from "firebase/firestore";
import Autocomplete from "react-google-autocomplete";
import Modal from "react-modal";
import { v4 as uuidv4 } from "uuid";
import ReactLoading from "react-loading";
import Stripe from "stripe";
import { IoIosCheckmarkCircle, IoIosCloseCircle } from "react-icons/io";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { useLanguage } from "../../LanguageContext";
import * as text from "../../translation.json";

import FileUpload from "./editLocationComponents/fileUpload";
import { firestore, GeoFirestore } from "../../firebase";
import AdPaymentScreen from "./adpaymentscreen";

const db = firestore;
const storage = getStorage();
const auth = getAuth();

const EditEvent = ({ currentBusinessID }) => {
  const { language } = useLanguage();
  const [eventInformation, setEventInformation] = useState({
    aboutBusiness: "",
    aboutEvent: "",
    active: false,
    averagePrice: "",
    paymentPrice: 0,
    endDate: 0,
    eventDate: 0,
    eventTime: null,
    location: null,
    shownOnBusinessPage: false,
    locationName: "",
    startDate: 0,
    tags: [],
    tagsLang: {
      en_US: [],
      nb_NO: [],
    },
    tags_enUS: [],
    aboutBusiness_enUS: "",
    aboutEvent_enUS: "",
    locationTags: [],
    locationTags_enUS: [],
  });
  const [missingFields, setMissingFields] = useState({
    name: false,
    location: false,
    startDate: false,
    endDate: false,
  });
  const [changingLocation, setChangingLocation] = useState(false);
  const [changingOwnerAndLocation, setChangingOwnerAndLocation] =
    useState(false);
  const [businessLocations, setBusinessLocations] = useState([]);
  const [eventLocation, setEventLocation] = useState(null);
  const [fileImage, setFileImage] = useState({
    file1: "",
    file2: "",
    file3: "",
    file4: "",
  });
  const [fileName, setFileName] = useState({
    file1: "",
    file2: "",
    file3: "",
    file4: "",
  });
  const [openEditPictureModal, setOpenEditPictureModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [newProfileImage, setNewProfileImage] = useState("");
  const [newProfileImagePreview, setNewProfileImagePreview] = useState("");
  const [newProfileFile, setNewProfileFile] = useState(null);
  const [locationInformation, setLocationinformation] = useState(null);
  const [continueToPayment, setContinueToPayment] = useState(false);
  const [paymentSuccessFull, setPaymentSuccessFull] = useState(false);
  const [userInformation, setUserInfomation] = useState(null);
  const [selectedEditMenu, setSelectedEditMenu] = useState("about");
  const [editLanguage, setEditLanguage] = useState("norwegian");
  const [freeDays, setFreedays] = useState(0);
  const [openSaveChangesModal, setOpenSaveChangesModal] = useState(false);
  const [savedChanges, setSavedChanges] = useState(false);
  const [openActivateModal, setOpenActivateModal] = useState(false);
  const [onChangeOwnerName, setOnChangeOwnerName] = useState("");
  const [onChangeLocationCoordinates, setOnChangeLocationCoordinates] =
    useState({ lat: null, lng: null });
  const [googlePlacesLongLat, setGooglePlacesLongLat] = useState(null);
  const [locationDestinationChanged, setLocationDestinationChanged] =
    useState(false);
  const [billingDays, setBillingDays] = useState(0);
  const [billingStartDate, setBillingStartDate] = useState("");
  const [billingEndDate, setBillingEndDate] = useState("");
  const [showPayment, setShowPayment] = useState(false);
  const [organiserInformation, setOrganiserInformation] = useState(null);
  const [businessInformation, setBusinessInformation] = useState(null);
  const navigate = useNavigate();

  let { edit } = useParams();
  useEffect(() => {
    document.title = "Rediger Arrangement - Mapli";
    auth.onAuthStateChanged(async function (user) {
      if (user) {
        const userDoc = doc(db, "users", user.uid);

        const userInfo = await getDoc(userDoc);
        setUserInfomation(userInfo.data());
      }
    });
  }, [auth]);

  useEffect(() => {
    const getEventInformation = async () => {
      const getEvent = doc(db, "events", edit);
      const eventInfo = await getDoc(getEvent);

      const userInfo = doc(db, "businesses", currentBusinessID);
      const userInformation = await getDoc(userInfo);
      const userData = userInformation.data();
      setBusinessInformation(userData);
      const menus = userData.menus;

      setFreedays(userData.freeEventDays ?? 0);

      setLocationinformation(eventInfo.data());
      if (eventInfo.data().profileImages) {
        eventInfo.data().profileImages.forEach((x, index) => {
          const fileName = `file${index + 1}`; // This will create "file1", "file2", etc.
          setFileImage((prevData) => ({
            ...prevData,
            [fileName]: x, // Dynamically assign the property name and value
          }));
        });
      }

      let activeLocations = [];

      for (const menu of menus) {
        // Assuming each menu has an identifier to get the specific locations collection
        const locationsRef = doc(db, "lokasjoner", menu);
        const querySnapshot = await getDoc(locationsRef);

        if (querySnapshot.data().active === true) {
          activeLocations.push(querySnapshot);
        }
      }
      setBusinessLocations(activeLocations);

      const getOrganiser = doc(
        db,
        "lokasjoner",
        eventInfo.data().eventOrganiser,
      );
      const organiser = await getDoc(getOrganiser);
      setOrganiserInformation(organiser.data());

      setEventInformation({
        aboutBusiness: eventInfo.data().aboutBusiness,
        aboutEvent: eventInfo.data().aboutEvent,
        active: eventInfo.data().active,
        averagePrice: eventInfo.data().averagePrice,
        paymentPrice: eventInfo.data().paymentPrice,
        endDate:
          eventInfo.data().endDate === eventInfo.data().eventDate
            ? eventInfo.data().eventDate + 86400
            : eventInfo.data().endDate,
        eventDate: eventInfo.data().eventDate,
        eventTime: eventInfo.data().eventTime,
        eventDateTime: eventInfo.data().eventDateTime,
        location: organiser.data(),
        eventOrganiser: eventInfo.data().eventOrganiser,
        eventOrganiserName: eventInfo.data().eventOrganiserName,
        eventNotified: eventInfo.data().eventNotified
          ? eventInfo.data().eventNotified
          : false,
        locationName: eventInfo.data().locationName,
        startDate: eventInfo.data().startDate,
        tags: eventInfo.data().tags,
        shownOnBusinessPage: eventInfo.data().shownOnBusinessPage
          ? eventInfo.data().shownOnBusinessPage
          : false,
        tagsLang: eventInfo.data().tagsLang,
        tags_enUS: eventInfo.data().tagsLang
          ? eventInfo.data().tagsLang.en_US
            ? eventInfo.data().tagsLang.en_US
            : []
          : [],
        aboutBusiness_enUS: eventInfo.data().aboutBusinessLang
          ? eventInfo.data().aboutBusinessLang.en_US
            ? eventInfo.data().aboutBusinessLang.en_US
            : ""
          : "",
        aboutEvent_enUS: eventInfo.data().aboutEventLang
          ? eventInfo.data().aboutEventLang.en_US
            ? eventInfo.data().aboutEventLang.en_US
            : ""
          : "",
        locationTags: eventInfo.data().locationTags
          ? eventInfo.data().locationTags
          : [],
        locationTags_enUS: eventInfo.data().locationTagsLang
          ? eventInfo.data().locationTagsLang.en_US
            ? eventInfo.data().locationTagsLang.en_US
            : []
          : [],
        imageResizeMode: eventInfo.data().imageResizeMode
          ? eventInfo.data().imageResizeMode
          : "contain",
      });

      setNewProfileImage(eventInfo.data().mainProfileImage);
    };
    const isValidID =
      currentBusinessID &&
      typeof currentBusinessID === "string" &&
      currentBusinessID.length > 0;

    if (isValidID) {
      getEventInformation();
    } else {
      console.log("Invalid business ID. Please check the ID or sign in.");
    }
  }, [edit, currentBusinessID]);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Adding leading zero
    const day = String(d.getDate()).padStart(2, "0"); // Adding leading zero
    return `${year}-${month}-${day}`;
  };

  const formatEndDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Adding leading zero
    const day = String(d.getDate()).padStart(2, "0"); // Adding leading zero
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    if (eventInformation.startDate !== 0 && eventInformation.eventDate !== 0) {
      const start = new Date(eventInformation.startDate * 1000);
      const end = new Date(eventInformation.eventDate * 1000);

      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      if (end >= start) {
        let newPriceInDays = (end - start) / (1000 * 60 * 60 * 24) + 1;

        if (freeDays > 0) {
          newPriceInDays = Math.max(newPriceInDays - freeDays, 0);
        }

        setBillingDays(newPriceInDays);
        setBillingStartDate(formatDate(eventInformation.startDate));
        setBillingEndDate(formatEndDate(eventInformation.eventDate));

        setEventInformation((prev) => ({
          ...prev,
          paymentPrice: newPriceInDays * 50,
        }));
      } else {
        setEventInformation((prev) => ({
          ...prev,
          paymentPrice: 0,
        }));
      }
    }
  }, [eventInformation.startDate, eventInformation.eventDate]);

  const onSetLocation = (event) => {
    setEventInformation((prevItems) => ({
      ...prevItems,
      location: event.data(),
    }));
    setEventLocation(event.id);
    setChangingLocation(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setNewProfileFile(file);
      setNewProfileImagePreview(URL.createObjectURL(file));
    }
  };

  const onSaveChanges = async () => {
    console.log(eventInformation.eventTime);

    if (
      fileImage.file1.length > 0 ||
      fileImage.file2.length > 0 ||
      fileImage.file3.length > 0 ||
      fileImage.file4.length > 0 ||
      locationInformation.profileImages !== undefined
    ) {
      let profileImages = ["", "", "", ""];

      if (locationInformation.profileImages !== undefined) {
        profileImages = [...locationInformation.profileImages];
      }

      let uploaded = false;

      profileImages.forEach((x, index) => {
        const file = `file${index + 1}`;

        if (fileImage[file] !== x && fileName[file] instanceof File) {
          uploaded = true;

          const uniqueKey = uuidv4();

          const profileImageArray = locationInformation.profileImages
            ? [...locationInformation.profileImages]
            : ["", "", "", ""];

          const storageRef = ref(storage, `images/${uniqueKey}`);

          uploadBytes(storageRef, fileName[file]).then((snapshot) => {
            console.log("Uploaded a blob or file!");

            getDownloadURL(snapshot.ref).then((downloadURL) => {
              console.log("File available at", downloadURL);

              profileImageArray[index] = downloadURL;

              const collectionRef = doc(db, "events", edit);

              updateDoc(collectionRef, { profileImages: profileImageArray })
                .then((docRef) => {
                  console.log("Document written with ID: ", docRef.id);
                })
                .catch((error) => {
                  console.error("Error adding document: ", error);
                });
            });
          });
        }
      });

      // FIX: handle copied images (no uploads)
      if (!uploaded) {
        const newProfileImageArray = [
          fileImage.file1 || "",
          fileImage.file2 || "",
          fileImage.file3 || "",
          fileImage.file4 || "",
        ];

        const collectionRef = doc(db, "events", edit);

        await updateDoc(collectionRef, {
          profileImages: newProfileImageArray,
        });
      }
    }

    // Save main profileImage

    if (
      newProfileImage !== locationInformation.mainProfileImage &&
      newProfileFile
    ) {
      const uniqueKey = uuidv4();

      const storage = getStorage();

      const storageRef = ref(storage, `images/${uniqueKey}`);

      uploadBytes(storageRef, newProfileFile).then((snapshot) => {
        console.log("Uploaded a blob or file!");

        getDownloadURL(snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);

          const collectionRef = doc(db, "events", edit);

          updateDoc(collectionRef, { mainProfileImage: downloadURL })
            .then((docRef) => {
              console.log("Document written with ID: ", docRef.id);
            })
            .catch((error) => {
              console.error("Error adding document: ", error);
            });
        });
      });
    }

    const time = (() => {
      if (!eventInformation.eventTime) return null;

      if (typeof eventInformation.eventTime === "string") {
        const [h = 0, m = 0] = eventInformation.eventTime
          .split(":")
          .map(Number);

        return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
      }

      const h = eventInformation.eventTime.hour ?? 0;
      const m = eventInformation.eventTime.minutes ?? 0;

      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    })();

    let hour, minutes;

    if (typeof eventInformation.eventTime === "string") {
      [hour, minutes] = eventInformation.eventTime.split(":").map(Number);
    } else {
      hour = eventInformation.eventTime.hour;
      minutes = eventInformation.eventTime.minutes;
    }

    const dateDateTime = new Date(eventInformation.eventDate * 1000);

    dateDateTime.setHours(hour);
    dateDateTime.setMinutes(minutes);
    dateDateTime.setSeconds(0);
    dateDateTime.setMilliseconds(0);

    const collectionRef = doc(db, "events", edit);

    await updateDoc(collectionRef, {
      aboutBusiness: eventInformation.aboutBusiness,
      aboutEvent: eventInformation.aboutEvent,
      active: eventInformation.active,
      paymentPrice: eventInformation.paymentPrice,
      averagePrice: eventInformation.averagePrice,
      endDate: eventInformation.eventDate + 86400,
      eventDate: eventInformation.eventDate,
      eventTime: time,
      eventDateTime: dateDateTime,
      eventOrganiser:
        eventLocation === null
          ? eventInformation.eventOrganiser
          : eventLocation,
      locationName: eventInformation.locationName,
      startDate: eventInformation.startDate ? eventInformation.startDate : null,
      tags: eventInformation.locationTags,
      tagsLang: {
        en_US: eventInformation.locationTags_enUS,
        nb_NO: eventInformation.locationTags,
      },
      aboutBusinessLang: {
        en_US: eventInformation.aboutBusiness_enUS,
        nb_NO: eventInformation.aboutBusiness,
      },
      aboutEventLang: {
        en_US: eventInformation.aboutEvent_enUS,
        nb_NO: eventInformation.aboutEvent,
      },
      locationTagsLang: {
        en_US: eventInformation.locationTags_enUS,
        nb_NO: eventInformation.locationTags,
      },
      locationTags: eventInformation.locationTags,
      imageResizeMode: eventInformation.imageResizeMode,
      onlyStudents: userInformation.studentOrganisasjon ? true : false,
    });

    setSavedChanges(true);
  };

  const TARGET_LANG = "en-US";

  const translateText = async (text) => {
    if (typeof text !== "string" || text.trim().length === 0) {
      return text;
    }

    try {
      const res = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/translateWithDeepL",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            text,
            toLang: TARGET_LANG,
            fromLang: eventInformation.lang ? eventInformation.lang : "nb_NO",
          }),
        },
      );

      if (!res.ok) {
        console.warn("Translate rejected:", await res.text());
        return text;
      }

      const json = await res.json();
      return json.text ?? text;
    } catch (err) {
      console.error("Translate error:", err);
      return text;
    }
  };

  const translateBatch = async (texts) => {
    try {
      const res = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/translateWithDeepL",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            texts,
            toLang: TARGET_LANG,
            fromLang: eventInformation.lang ? eventInformation.lang : "nb_NO",
          }),
        },
      );

      const json = await res.json();
      return json.text ?? texts;
    } catch (err) {
      console.error("Batch translate error:", err);
      return texts;
    }
  };

  const onTranslateText = async (x) => {
    try {
      if (x === "aboutBusiness") {
        const translated = await translateText(eventInformation.aboutBusiness);

        setEventInformation((prev) => ({
          ...prev,
          aboutBusiness_enUS: translated,
        }));
      } else if (x === "aboutEvent") {
        const translated = await translateText(eventInformation.aboutEvent);

        setEventInformation((prev) => ({
          ...prev,
          aboutEvent_enUS: translated,
        }));
      } else if (x === "tags") {
        if (!Array.isArray(eventInformation.tags)) return;

        const translatedTags = await translateBatch(eventInformation.tags);

        setEventInformation((prev) => ({
          ...prev,
          tags_enUS: translatedTags,
        }));
      } else if (x === "maintags") {
        if (!Array.isArray(eventInformation.locationTags)) return;

        const translatedMainTags = await translateBatch(
          eventInformation.locationTags,
        );

        setEventInformation((prev) => ({
          ...prev,
          locationTags_enUS: translatedMainTags,
        }));
      }
    } catch (err) {
      console.error("onTranslateText error:", err);
    }
  };

  const onActivateLocation = async () => {
    console.log(organiserInformation.mapliPartner);
    console.log(organiserInformation);
    const dbCollection = doc(db, "events", edit);
    if (eventInformation.onlyStudents) {
      await updateDoc(dbCollection, {
        active: true,
        shownOnBusinessPage: true,
      });
    } else if (organiserInformation.mapliPartner) {
      await updateDoc(dbCollection, {
        active: true,
        shownOnBusinessPage: true,
      });
    } else {
      await updateDoc(dbCollection, {
        shownOnBusinessPage: true,
      });
    }

    if (organiserInformation.canBeSubscribedTo) {
      if (eventInformation.eventNotified !== true) {
        await fetch(
          "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/sendPushToOrganizer",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              organizerId: eventInformation.eventOrganiser,
              title: `${organiserInformation.locationName} - ${eventInformation.locationName}`,
              body: `${organiserInformation.locationName} har lagt til et nytt arrangement!`,
              data: {
                deepLink: `https://app.mapli.no/place/${edit}`,
              },
            }),
          },
        );
        await updateDoc(dbCollection, {
          eventNotified: true,
        });
        setEventInformation({ ...eventInformation, eventNotified: true });
      }
    }
    setEventInformation({ ...eventInformation, shownOnBusinessPage: true });
    setOpenActivateModal(false);
  };

  const onDeactivateLocation = async () => {
    const dbCollection = doc(db, "events", edit);

    updateDoc(dbCollection, {
      active: false,
      shownOnBusinessPage: false,
    });
    setEventInformation({ ...eventInformation, shownOnBusinessPage: false });
    setOpenActivateModal(false);
  };

  const onUseLocationImages = () => {
    console.log(eventInformation.location.profileImages);
    // setEventInformation({
    //   ...eventInformation,
    //   profileImages: eventInformation.location.profileImages,
    // });
    eventInformation.location.profileImages.forEach((x, index) => {
      const fileName = `file${index + 1}`; // This will create "file1", "file2", etc.
      setFileImage((prevData) => ({
        ...prevData,
        [fileName]: x, // Dynamically assign the property name and value
      }));
      // setFileName((prevData) => ({
      //   ...prevData,
      //   [fileName]: x,
      // }));
    });
  };

  useEffect(() => {
    if (googlePlacesLongLat !== null) {
      setOnChangeLocationCoordinates({
        lat: googlePlacesLongLat.lat(),
        lng: googlePlacesLongLat.lng(),
      });
    }
  }, [googlePlacesLongLat]);

  const onChangeLocationInformation = async () => {
    let changed = false;

    if (onChangeOwnerName && onChangeOwnerName.trim() !== "") {
      const collectionRef = doc(db, "events", edit);
      await updateDoc(collectionRef, {
        eventOrganiserName: onChangeOwnerName,
      });
      changed = true;
    }

    if (onChangeLocationCoordinates.lat && onChangeLocationCoordinates.lng) {
      const newLat = onChangeLocationCoordinates.lat;
      const newLng = onChangeLocationCoordinates.lng;

      const geocollection = GeoFirestore.collection("events");

      await geocollection.doc(edit).update({
        coordinates: new GeoPoint(newLat, newLng),
        lat: newLat,
        lng: newLng,
      });
      changed = true;
    }

    if (changed) setLocationDestinationChanged(true);
  };

  return eventInformation.location === null ? (
    <></>
  ) : changingOwnerAndLocation ? (
    <>
      <div className='box' style={{ padding: 25 }}>
        <h1>Hvor holdes arrangementet?</h1>
        <div style={{ flexDirection: "row", display: "flex", gap: 30 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "30%",
            }}>
            <label className='editPageLabel'>Søk på adresse eller sted</label>
            <Autocomplete
              options={{
                types: ["places"] + ["establishment"] + ["address"],
              }}
              placeholder='Søk etter lokasjon eller adresse'
              apiKey={"AIzaSyBzqNdOb1GQUpeP2bFfsed64Yp_hEALAQ4"}
              onPlaceSelected={(place) => {
                setGooglePlacesLongLat(place.geometry.location);
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "30%",
            }}>
            <label className='editPageLabel'>
              Endre visningsnavn på hvor arrangementet holdes
            </label>
            <input
              placeholder={eventInformation.eventOrganiserName}
              value={onChangeOwnerName}
              initialvalue={eventInformation.eventOrganiserName}
              onChange={(e) => setOnChangeOwnerName(e.target.value)}
            />
          </div>
        </div>
        {locationDestinationChanged && (
          <p style={{ color: "green", marginTop: 10 }}>
            Lokasjonsinformasjon oppdatert!
          </p>
        )}
        <div style={{ marginTop: 30 }}>
          <button
            onClick={() => {
              setChangingOwnerAndLocation(false);
              setGooglePlacesLongLat(null);
              setOnChangeLocationCoordinates({ lat: null, lng: null });
              setOnChangeOwnerName("");
              setLocationDestinationChanged(false);
            }}
            className='universalButton'
            style={{ marginRight: 10 }}>
            Tilbake / Avbryt
          </button>
          <button
            onClick={() => {
              onChangeLocationInformation();
            }}
            className='universalButtonRed'>
            Lagre endringer
          </button>
        </div>
      </div>
    </>
  ) : changingLocation ? (
    <>
      <div>
        <h1>Hvilken lokasjon gjelder arragementet for?</h1>
        {businessLocations.length > 0 ? (
          businessLocations.map((lokasjonsInformasjon, rowIndex) => {
            return (
              <div
                key={rowIndex}
                className='box'
                style={{ marginBottom: "15px" }}>
                <div className='businessOverView'>
                  <label className='locationNameLabel'>
                    {lokasjonsInformasjon.data()?.locationName}
                  </label>
                  <label>
                    {lokasjonsInformasjon.data()?.adress
                      ? lokasjonsInformasjon.data()?.adress
                      : "-"}
                  </label>
                  <div>
                    <a
                      onClick={() => {
                        onSetLocation(lokasjonsInformasjon);
                      }}
                      className='universalButtonRed'
                      style={{ marginLeft: "5px" }}>
                      Velg
                    </a>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p style={{ textAlign: "center", marginTop: 0 }}>
            Ingen lokasjoner å vise til
          </p>
        )}
      </div>
    </>
  ) : (
    <>
      <div>
        <h1>Redigerer {eventInformation.locationName}</h1>
        <div>
          <label
            style={{
              color: eventInformation.shownOnBusinessPage
                ? "#52c78c"
                : "#f9615b",
              fontWeight: "500",
            }}>
            {eventInformation.shownOnBusinessPage
              ? "Vises på Profilen"
              : "Ikke aktiv (vises ikke på profilen)"}
          </label>
          <button
            className='universalButton'
            style={{ marginLeft: "10px" }}
            onClick={() => {
              setOpenActivateModal(true);
            }}>
            {eventInformation.shownOnBusinessPage ? "Deaktiver" : "Aktiver"}
          </button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: userInformation.admin
              ? "space-between"
              : "flex-end",
          }}>
          {userInformation.admin && (
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <div>
                <button
                  onClick={() => {
                    setOpenPublishModal(true);
                  }}
                  className='editMenuButtons'
                  style={{
                    width: 200,
                  }}>
                  Promoter arrangement
                </button>
              </div>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div>
              <button
                onClick={() => {
                  if (editLanguage !== "english") {
                    setEditLanguage("english");
                  } else {
                    setEditLanguage("norwegian");
                  }
                }}
                className='editMenuButtons'
                style={
                  editLanguage === "english"
                    ? {
                        color: "#f9615b",
                        backgroundColor: "white",
                        border: "white",
                      }
                    : {}
                }>
                Engelsk
              </button>
            </div>
          </div>
        </div>
        <div
          className='box'
          style={{
            borderTopLeftRadius: 0,
            padding: 25,
            paddingRight: 35,
            marginBottom: "50px",
          }}>
          {/* Top */}
          <div className='editAboutTop'>
            {/* Picture */}
            {editLanguage !== "english" ? (
              <div className='editAboutPictureContainer'>
                <div className='editPicture'>
                  {newProfileImage && newProfileImage.length > 1 ? (
                    <img
                      src={newProfileImage}
                      alt='Preview'
                      className='editPicture'
                      style={{
                        objectFit:
                          eventInformation.imageResizeMode ?? "contain",
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <a
                  className='editPageLink'
                  href='#'
                  onClick={() => {
                    setOpenEditPictureModal(true);
                  }}>
                  Rediger bilde
                </a>
                <>
                  <a
                    style={{ fontSize: 13 }}
                    href='#'
                    onClick={() => {
                      eventInformation.imageResizeMode !== "cover"
                        ? setEventInformation({
                            ...eventInformation,
                            imageResizeMode: "cover",
                          })
                        : setEventInformation({
                            ...eventInformation,
                            imageResizeMode: "contain",
                          });
                    }}>
                    Endre bildets tilpasning (nå:{" "}
                    {eventInformation.imageResizeMode === "cover"
                      ? "Fyller hele området"
                      : "Vis hele bildet"}
                    )
                  </a>
                </>
              </div>
            ) : (
              <></>
            )}
            {/* Name + Tags */}
            <div className='editAboutNameTagsContainer'>
              {editLanguage !== "english" ? (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label className='editPageLabel'>Navn</label>
                  <input
                    placeholder='Navn'
                    value={eventInformation.locationName}
                    onChange={(x) => {
                      setEventInformation((prevItems) => ({
                        ...prevItems,
                        locationName: x.target.value,
                      }));
                    }}
                  />
                </div>
              ) : (
                <></>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}>
                {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "15px",
                    width: "58%",
                  }}> */}
                {/* <label className='editPageLabel'>
                    {editLanguage !== "english" ? (
                      "Tags"
                    ) : (
                      <>
                        Tags (engelske tags){" "}
                        <a
                          href='#'
                          class='editPageLink'
                          onClick={() => {
                            onTranslateText("tags");
                          }}>
                          Oversett automatisk
                        </a>
                      </>
                    )}
                  </label> */}
                {/* <input
                    placeholder='Søkeord for lokasjonen (eg. burger, asiatisk, konserter etc.)'
                    value={
                      editLanguage !== "english"
                        ? eventInformation.tags.join(",")
                        : eventInformation.tags_enUS.join(",")
                    }
                    onChange={(e) => {
                      if (editLanguage !== "english") {
                        // Get the current input value directly
                        const inputValue = e.target.value;

                        // Split the input based on commas without altering spaces
                        const newTags = inputValue.split(",").map((tag) => {
                          const trimmedTag = tag.trim();
                          return (
                            trimmedTag.charAt(0).toUpperCase() +
                            trimmedTag.slice(1).toLowerCase()
                          );
                        });

                        // Update the state with these new tags without trimming spaces
                        setEventInformation({
                          ...eventInformation,
                          tags: newTags,
                        });
                      } else {
                        // Get the current input value directly
                        const inputValue = e.target.value;

                        // Split the input based on commas without altering spaces
                        const newTags = inputValue.split(",").map((tag) => {
                          const trimmedTag = tag.trim();
                          return (
                            trimmedTag.charAt(0).toUpperCase() +
                            trimmedTag.slice(1).toLowerCase()
                          );
                        });

                        // Update the state with these new tags without trimming spaces
                        setEventInformation({
                          ...eventInformation,
                          tags_enUS: newTags,
                        });
                      }
                    }}
                  /> */}
                {/* </div> */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "40%",
                    marginTop: "15px",
                  }}>
                  <label className='editPageLabel'>
                    {editLanguage !== "english" ? (
                      "Hoved tags"
                    ) : (
                      <>
                        Hoved tags (engelske tags){" "}
                        <a
                          href='#'
                          class='editPageLink'
                          onClick={() => {
                            onTranslateText("maintags");
                          }}>
                          Oversett automatisk
                        </a>
                      </>
                    )}{" "}
                    <a href='/faq#tags'>
                      <BsFillQuestionCircleFill color='#4550e2' size='17px' />
                    </a>
                  </label>
                  <input
                    placeholder='Synlige tags på profilen (eg. konsert, sportsarrangement, etc.)'
                    value={
                      editLanguage !== "english"
                        ? eventInformation.locationTags.join(",")
                        : eventInformation.locationTags_enUS.join(",")
                    }
                    onChange={(e) => {
                      if (editLanguage !== "english") {
                        // Get the current input value directly
                        const inputValue = e.target.value;

                        // Split the input based on commas without altering spaces
                        const newTags = inputValue.split(",");

                        // Update the state with these new tags without trimming spaces
                        setEventInformation({
                          ...eventInformation,
                          locationTags: newTags,
                        });
                      } else {
                        // Get the current input value directly
                        const inputValue = e.target.value;

                        // Split the input based on commas without altering spaces
                        const newTags = inputValue
                          .split(",")
                          .map((tag) => tag.trim());

                        // Update the state with these new tags without trimming spaces
                        setEventInformation({
                          ...eventInformation,
                          locationTags_enUS: newTags,
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* end topp!! */}
          {editLanguage !== "english" ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "30%",
                }}>
                <label className='editPageLabel'>Dato for arrangementet</label>
                <input
                  style={{ paddingRight: "10px" }}
                  type='date'
                  value={formatDate(eventInformation.eventDate * 1000)}
                  onChange={(x) => {
                    setEventInformation((prevItems) => ({
                      ...prevItems,
                      eventDate: new Date(x.target.value).getTime() / 1000,
                    }));
                  }}
                />
                <label
                  style={{
                    display: missingFields.name ? "block" : "none",
                    color: "#f9615b",
                  }}>
                  Her mangler det noe!
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "30%",
                }}>
                <label className='editPageLabel'>
                  Tidspunkt for arrangementet
                </label>
                <input
                  className='timepicker'
                  type='time'
                  style={{ width: "100%" }}
                  value={
                    typeof eventInformation.eventTime === "object"
                      ? `${String(eventInformation.eventTime.hour).padStart(
                          2,
                          "0",
                        )}:${String(
                          eventInformation.eventTime.minutes,
                        ).padStart(2, "0")}`
                      : typeof eventInformation.eventTime === "string"
                        ? eventInformation.eventTime
                        : ""
                  }
                  onChange={(x) => {
                    if (x.target.value === "") {
                      setEventInformation((prevState) => ({
                        ...prevState,
                        eventTime: null,
                      }));
                    } else {
                      const [hrs, mins] = x.target.value.split(":").map(Number);
                      setEventInformation((prevState) => ({
                        ...prevState,
                        eventTime: {
                          // Ensure hours and minutes are stored as numbers
                          hour: hrs || 0, // Fallback to 0 if hrs is NaN
                          minutes: mins || 0, // Fallback to 0 if mins is NaN
                        },
                      }));
                    }
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "30%",
                }}>
                <label className='editPageLabel'>Billettpris</label>
                <input
                  style={{ paddingRight: "10px" }}
                  placeholder='Billettpris'
                  type='number'
                  value={eventInformation.averagePrice}
                  onChange={(x) => {
                    const value = x.target.value;

                    setEventInformation((prev) => ({
                      ...prev,
                      averagePrice: value === "" ? "" : Number(value),
                    }));
                  }}
                />
              </div>
            </div>
          ) : (
            <></>
          )}
          {editLanguage !== "english" ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "30%",
                }}>
                <label className='editPageLabel'>
                  Hvilken lokasjon gjelder arragementet for?
                </label>
                <input
                  placeholder='Lokasjon'
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                  onClick={() => {
                    setChangingLocation(true);
                  }}
                  value={
                    eventInformation.location !== null
                      ? eventInformation.location.adress !== undefined
                        ? eventInformation.location.locationName +
                          " - " +
                          eventInformation.location.adress
                        : eventInformation.location.locationName
                      : ""
                  }
                />
                <label
                  style={{
                    display: missingFields.location ? "block" : "none",
                    color: "#f9615b",
                  }}>
                  Her mangler det noe!
                </label>
              </div>
              {/* Place event on different location */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "30%",
                }}>
                <label className='editPageLabel'>
                  Plasser arrangementet på en annen adresse enn{" "}
                  {eventInformation.location?.locationName}?
                </label>
                <input
                  placeholder='Lokasjon'
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                  onClick={() => {
                    setChangingOwnerAndLocation(true);
                  }}
                  value={eventInformation.eventOrganiserName}
                />
                <label
                  style={{
                    display: missingFields.location ? "block" : "none",
                    color: "#f9615b",
                  }}>
                  Her mangler det noe!
                </label>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "15px",
            }}>
            <label className='editPageLabel'>
              {editLanguage !== "english" ? (
                "Skriv en kort beskrivende tekst om arrangementet (max 70 ord)"
              ) : (
                <>
                  Skriv en kort beskrivende tekst om arrangementet (max 70 ord)
                  (engelsk beskrivelse){" "}
                  <a
                    href='#'
                    class='editPageLink'
                    onClick={() => {
                      onTranslateText("aboutBusiness");
                    }}>
                    Oversett automatisk
                  </a>
                </>
              )}
            </label>
            <textarea
              placeholder='Om arrangementet (max 70 ord)'
              value={
                editLanguage !== "english"
                  ? eventInformation.aboutBusiness
                  : eventInformation.aboutBusiness_enUS
              }
              onChange={(x) => {
                if (editLanguage !== "english") {
                  setEventInformation({
                    ...eventInformation,
                    aboutBusiness: x.target.value,
                  });
                } else {
                  setEventInformation({
                    ...eventInformation,
                    aboutBusiness_enUS: x.target.value,
                  });
                }
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "15px",
            }}>
            <label className='editPageLabel'>
              {editLanguage !== "english" ? (
                "Skriv litt om hvordan man kan kjøpe billetter til arrangementet (her kan linker inkluderes)"
              ) : (
                <>
                  Skriv litt om hvordan man kan kjøpe billetter til
                  arrangementet (her kan linker inkluderes) (engelsk
                  informasjon){" "}
                  <a
                    href='#'
                    class='editPageLink'
                    onClick={() => {
                      onTranslateText("aboutEvent");
                    }}>
                    Oversett automatisk
                  </a>
                </>
              )}
            </label>
            <textarea
              placeholder='Informasjon om hvordan en kan kjøpe billetter, pris, aldersgrense, når åpner dørene, etc.'
              value={
                editLanguage !== "english"
                  ? eventInformation.aboutEvent
                  : eventInformation.aboutEvent_enUS
              }
              onChange={(x) => {
                if (editLanguage !== "english") {
                  setEventInformation({
                    ...eventInformation,
                    aboutEvent: x.target.value,
                  });
                } else {
                  setEventInformation({
                    ...eventInformation,
                    aboutEvent_enUS: x.target.value,
                  });
                }
              }}
            />
          </div>

          {editLanguage !== "english" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "15px",
              }}>
              <label className='editPageLabel'>
                Last opp bilder av lokasjonen (max 4)
                <a
                  href='#'
                  class='editPageLink'
                  onClick={() => {
                    onUseLocationImages();
                  }}>
                  Bruk bilder fra lokasjonens profil
                </a>
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "5px",
                }}>
                <div style={{ display: "flex" }}>
                  <FileUpload
                    id='file1'
                    fileImage={fileImage}
                    setFileImage={setFileImage}
                    setFileName={setFileName}
                  />
                  <div style={{ marginLeft: "10px" }}>
                    <FileUpload
                      id='file2'
                      fileImage={fileImage}
                      setFileImage={setFileImage}
                      setFileName={setFileName}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: "10px" }}>
                  <FileUpload
                    id='file3'
                    fileImage={fileImage}
                    setFileImage={setFileImage}
                    setFileName={setFileName}
                  />
                  <div style={{ marginLeft: "10px" }}>
                    <FileUpload
                      id='file4'
                      fileImage={fileImage}
                      setFileImage={setFileImage}
                      setFileName={setFileName}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          <div>
            {/* {eventInformation.active ? ( */}
            <button
              onClick={() => setOpenSaveChangesModal(true)}
              className='universalButtonRed'
              style={{
                width: "150px",
                marginTop: "25px",
                marginRight: "10px",
              }}>
              Lagre endringer
            </button>
            {/* ) : (
            // ) : (
            //   <button
            //     onClick={() => (onSaveChanges(), setOpenPublishModal(true))}
            //     className='universalButtonRed'
            //     style={{
            //       width: "150px",
            //       marginTop: "25px",
            //       marginRight: "10px",
            //     }}>
            //     Gå videre
            //   </button>
            // )} */}
            <button
              style={{
                width: "150px",
                marginTop: "25px",
              }}
              onClick={() => {}}
              className='universalButton'>
              Avbryt
            </button>
          </div>
        </div>
      </div>
      {/* Modals */}
      <Modal
        isOpen={openActivateModal}
        onRequestClose={() => {
          setOpenActivateModal(false);
        }}
        className='modalStyle'
        style={{
          content: {
            width: "17%",
          },
        }}>
        {eventInformation.shownOnBusinessPage ? (
          <div className='editActiveModal'>
            <label className='editPageLabel'>
              {text[language].sureDeactivate}
            </label>
            <div className='editActiveModalButtonContainer'>
              <button
                onClick={() => {
                  onDeactivateLocation();
                }}
                className='universalButton'
                style={{
                  width: "70%",
                  margin: 0,
                }}>
                {text[language].yesdeactivate}
              </button>
              <button
                onClick={() => {
                  setOpenActivateModal(false);
                }}
                className='universalButtonRed'
                style={{
                  width: "70%",
                  marginTop: 10,
                  marginBottom: 0,
                }}>
                {text[language].notakeback}
              </button>
            </div>
          </div>
        ) : (
          <div className='editActiveModal'>
            <label className='editPageLabel'>
              {text[language].sureActivate}
            </label>
            {organiserInformation.canBeSubscribedTo &&
              !eventInformation.eventNotified && (
                <>
                  <p style={{ color: "gray", marginTop: 10 }}>
                    Ved å aktivere arrangementet så varsles dine følgere om at
                    et nytt arrangement er tilgjengelig på din profil!
                  </p>
                  <p style={{ color: "gray", marginTop: 10 }}>
                    Antall følgere:{" "}
                    <label style={{ color: "black" }}>
                      {organiserInformation.notificationCount}
                    </label>
                  </p>
                </>
              )}
            <div className='editActiveModalButtonContainer'>
              <button
                onClick={() => {
                  onActivateLocation();
                }}
                className='universalButtonRed'
                style={{
                  width: "70%",
                  margin: 0,
                }}>
                {text[language].yesactivate}
              </button>
              <button
                onClick={() => {
                  setOpenActivateModal(false);
                }}
                className='universalButton'
                style={{
                  width: "70%",
                  marginTop: 10,
                  marginBottom: 0,
                }}>
                {text[language].notakeback}
              </button>
            </div>
          </div>
        )}
      </Modal>
      <Modal
        isOpen={openEditPictureModal}
        onRequestClose={() => (
          setOpenEditPictureModal(false),
          setNewProfileImage("")
        )}
        className='modalStyle'
        style={{
          content: {
            width: "17%",
          },
        }}>
        <div className='editActiveModal'>
          <label className='editPageLabel'>Endre lokasjonens hovedbilde</label>
          <div className='editActiveModalButtonContainer'>
            <input type='file' onChange={handleImageChange} />
            {newProfileImagePreview && (
              <img
                src={newProfileImagePreview}
                alt='Preview'
                height='125px'
                width='125px'
              />
            )}
            <button
              onClick={() => (
                setOpenEditPictureModal(false),
                setNewProfileImage(newProfileImagePreview)
              )}
              className='universalButtonRed'
              style={{
                width: "70%",
                marginTop: 10,
                marginBottom: 0,
              }}>
              Bruk bilde
            </button>
            <button
              onClick={() => (
                setOpenEditPictureModal(false),
                setNewProfileImagePreview("")
              )}
              className='universalButton'
              style={{
                width: "70%",
                marginTop: 10,
                marginBottom: 0,
              }}>
              Avbryt
            </button>
          </div>
        </div>
      </Modal>
      {/* Save Changes Modal */}
      <Modal
        isOpen={openSaveChangesModal}
        onRequestClose={() => (
          setOpenSaveChangesModal(false),
          setSavedChanges(false)
        )}
        className='modalStyle'
        style={{
          content: {
            width: "20%",
          },
        }}>
        <div className='editActiveModal'>
          <label className='editPageLabel'>
            Lagerer og publiserer endringer! Er du sikker på at du vil lagre og
            publisere endringene for offentligheten?
          </label>
          <div className='editActiveModalButtonContainer'>
            <div
              style={{
                display: savedChanges ? "block" : "none",
                color: "#52c78c",
                marginBottom: "5px",
              }}>
              Endringer lagret!
            </div>
            <button
              onClick={onSaveChanges}
              className='universalButtonRed'
              style={{
                width: "240px",
                margin: 0,
              }}>
              Ja, lagre og publiser endringer
            </button>
            <button
              onClick={() => (
                setOpenSaveChangesModal(false),
                setSavedChanges(false)
              )}
              className='universalButton'
              style={{
                width: "70%",
                marginTop: 10,
                marginBottom: 0,
              }}>
              Nei, ta meg tilbake
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={openPublishModal}
        onRequestClose={() => {
          setOpenPublishModal(false);
          setContinueToPayment(false);
        }}
        className='modalStyle'
        style={{
          content: {
            width: "35%",
            height: "35%",
            position: "relative",
          },
        }}>
        <>
          <div className='editActiveModal'>
            <label className='editPageLabel'>Publiser annonse</label>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  paddingRight: "15px",
                }}>
                <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
                  Annonsen starter:
                </label>
                <input
                  style={{
                    width: "70%",
                    textAlign: "center",
                    paddingRight: 15,
                  }}
                  min={new Date().toISOString().split("T")[0]}
                  max={
                    eventInformation.eventDate === 0
                      ? ""
                      : formatDate(eventInformation.eventDate * 1000)
                  }
                  type='date'
                  value={
                    eventInformation.startDate === 0
                      ? ""
                      : formatDate(eventInformation.startDate * 1000)
                  }
                  onChange={(x) => {
                    setEventInformation((prevItems) => ({
                      ...prevItems,
                      startDate: new Date(x.target.value).getTime() / 1000,
                    }));
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  paddingLeft: "15px",
                }}>
                <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
                  Annonsen slutter:
                </label>
                <input
                  style={{
                    width: "70%",
                    textAlign: "center",
                    paddingRight: 15,
                  }}
                  disabled
                  value={formatEndDate(eventInformation.eventDate * 1000)}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}>
              <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
                Pris:
              </label>
              <input
                style={{
                  width: "20%",
                  textAlign: "center",
                  paddingRight: 15,
                }}
                disabled
                value={eventInformation.paymentPrice}
              />
            </div>
            <div
              style={{
                position: "absolute",
                bottom: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "90%",
              }}>
              <label>
                Ved å publisere en annonse godkjenner du vilkårene for{" "}
                <a href='#'>promotering av arrangement</a>
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  width: "100%",
                  marginTop: "10px",
                }}></div>
              <div
                style={{
                  display: "flex",
                  // alignItems: "center",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                }}>
                <button
                  onClick={() => setContinueToPayment(true)}
                  className='universalButtonRed'
                  style={{
                    width: "45%",
                    opacity:
                      !eventInformation.startDate ||
                      eventInformation.eventDate < eventInformation.startDate
                        ? 0.5
                        : 1,
                    cursor:
                      !eventInformation.startDate ||
                      eventInformation.eventDate < eventInformation.startDate
                        ? "not-allowed"
                        : "pointer",
                  }}
                  disabled={
                    !eventInformation.startDate ||
                    eventInformation.eventDate < eventInformation.startDate
                  }>
                  Gå videre
                </button>
                <button
                  onClick={() => setOpenPublishModal(false)}
                  className='universalButton'
                  style={{
                    width: "45%",
                  }}>
                  Avbryt
                </button>
              </div>
            </div>
          </div>
        </>
      </Modal>

      {/* Payment screen — rendered outside the modal, it has its own overlay */}
      {continueToPayment && (
        <AdPaymentScreen
          days={billingDays}
          startDate={formatEndDate(eventInformation.startDate * 1000)}
          endDate={formatEndDate(eventInformation.eventDate * 1000)}
          uid={currentBusinessID}
          pricePerDay={50}
          userCredits={businessInformation.credits}
          hasInvoice={businessInformation.billingType === "invoice"}
          eventName={eventInformation.locationName}
          eventId={edit}
          startDateSeconds={eventInformation.startDate} // already in seconds
          onClose={() => setContinueToPayment(false)}
          onSuccess={({ method }) => {
            setContinueToPayment(false);
            setOpenPublishModal(false);
            navigate("/booking-confirmed", { state: { method } });
          }}
        />
      )}
    </>
  );
};

export default EditEvent;
